export default "__VITE_ASSET__BIaL5yb2__"